import { CommonTableUI } from "../../TableTemplate/common";
import TableTemplate from "../../TableTemplate/tableTemplate";
import { getDeltaHedgeExeAllowedTradeLogsTable } from "../../../Requests/deltaHedgeExe";
import { ISearchParameters } from "../../../Interfaces/TableInterfaces";

interface IProps {
  id: number;
}

const DeltaHedgeExeTaskLogsTable = ({ id }: IProps) => {
  return (
    <TableTemplate<ISearchParameters, any>
      TableUI={({ reports, onAction }) => (
        <CommonTableUI reports={reports} onAction={onAction} />
      )}
      getDataTable={getDeltaHedgeExeAllowedTradeLogsTable}
      initialSearchParameters={{ id }}
    />
  );
};

export default DeltaHedgeExeTaskLogsTable;
